import { Component } from '@angular/core';

@Component({
  selector: 'app-billing-talent-purchase',
  templateUrl: './billing-talent-purchase.component.html',
  styleUrls: ['./billing-talent-purchase.component.css']
})
export class BillingTalentPurchaseComponent {

}
